// src/pages/RestaurantOwner/Settings.jsx - WITH HSN CODE FIELD

import React, { useState, useEffect } from 'react';
import StorageService from '../../services/StorageService';
import { useApp } from '../../context/AppContext';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../services/firebaseConfig';
import { Loader, Lock, User, Building2, MapPin, Phone, Mail, FileText, Shield, Save, AlertCircle, CheckCircle, Eye, EyeOff, Hash ,Star} from 'lucide-react';
import AuthService from '../../services/AuthService';
import KitchenStaffService from '../../services/KitchenStaffService';
import { Users, Plus } from 'lucide-react';

const OwnerSettings = ({ restaurantId }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState('profile');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    name: '',
    city: '',
    state: '',
    country: '',
    address: '',
    gstNo: '',
    hsnCode: '',
    ownerPhone: '',
    email: '',
    pinCode: '',
    googlePlaceId: '' // ✅ ADD THIS LINE

  });

  // kot
const [kitchenStaff, setKitchenStaff] = useState([]);
const [showKitchenModal, setShowKitchenModal] = useState(false);
const [kitchenFormData, setKitchenFormData] = useState({
  name: '',
  email: '',
  password: ''
});
const [kitchenSaving, setKitchenSaving] = useState(false);
const loadKitchenStaff = async () => {
  try {
    const staff = await KitchenStaffService.getKitchenStaff(restaurantId);
    setKitchenStaff(staff);
  } catch (error) {
    console.error('Error loading kitchen staff:', error);
  }
};

  //kot end
  const [message, setMessage] = useState({ type: '', text: '' });
  const { changePassword , user} = useApp();

  useEffect(() => {
    loadSettings();
  }, [restaurantId]);
//kot
useEffect(() => {
  loadKitchenStaff();
}, [restaurantId]);
//kot
  const loadSettings = async () => {
    try {
      setLoading(true);
      const restaurant = await StorageService.getRestaurant(restaurantId);

      if (restaurant) {
        setFormData({
          username: restaurant.username || '',
          currentPassword: '',
          newPassword: '',
          confirmPassword: '',
          name: restaurant.name || '',
          city: restaurant.city || '',
          state: restaurant.state || '',
          country: restaurant.country || '',
          address: restaurant.address || '',
          gstNo: restaurant.gstNo || '',
          hsnCode: restaurant.hsnCode || '996331',
          ownerPhone: restaurant.ownerPhone || '',
          email: restaurant.email || '',
          pinCode: restaurant.pinCode || '',
          googlePlaceId: restaurant.googlePlaceId || '' // ✅ ADD THIS LINE
        });
      }
    } catch (error) {
      console.error('❌ Error loading settings:', error);
      setMessage({ type: 'error', text: 'Failed to load settings' });
    } finally {
      setLoading(false);
    }
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);
      setMessage({ type: '', text: '' });

      const updateData = {
        name: formData.name,
        city: formData.city,
        state: formData.state,
        country: formData.country,
        address: formData.address,
        gstNo: formData.gstNo,
        hsnCode: formData.hsnCode || '996331',
        ownerPhone: formData.ownerPhone,
        pinCode: formData.pinCode,
        googlePlaceId: formData.googlePlaceId, // ✅ ADD THIS LINE
        updatedAt: new Date().toISOString()
      };

      const restaurantRef = doc(db, 'restaurants', restaurantId);
      await updateDoc(restaurantRef, updateData);

      StorageService.clearCache();

      setMessage({ type: 'success', text: '✅ Profile updated successfully!' });
       

      setTimeout(() => {
        setMessage({ type: '', text: '' });
      }, 3000);
    } catch (error) {
      console.error('❌ Error updating profile:', error);
      setMessage({ type: 'error', text: 'Failed to update profile. Please try again.' });
    } finally {
      setSaving(false);
    }
  };
//kot
const handleCreateKitchenStaff = async (e) => {
  e.preventDefault();
  
  if (!kitchenFormData.name || !kitchenFormData.email || !kitchenFormData.password) {
    alert('All fields are required');
    return;
  }

  if (kitchenFormData.password.length < 6) {
    alert('Password must be at least 6 characters');
    return;
  }

  try {
    setKitchenSaving(true);
    
    const result = await KitchenStaffService.createKitchenStaff(restaurantId, {
      ...kitchenFormData,
      createdBy: user?.username || 'Owner'
    });

    if (result.success) {
      alert('✅ Kitchen staff created successfully!');
      setShowKitchenModal(false);
      setKitchenFormData({ name: '', email: '', password: '' });
      await loadKitchenStaff();
    } else {
      alert(`❌ ${result.message}`);
    }
  } catch (error) {
    alert('Failed to create kitchen staff');
  } finally {
    setKitchenSaving(false);
  }
};

const handleToggleKitchenStaff = async (staffId, currentStatus) => {
  if (!window.confirm(`Are you sure you want to ${currentStatus ? 'deactivate' : 'activate'} this kitchen staff?`)) {
    return;
  }

  const result = await KitchenStaffService.updateKitchenStaffStatus(restaurantId, staffId, !currentStatus);
  
  if (result.success) {
    await loadKitchenStaff();
  } else {
    alert('Failed to update kitchen staff');
  }
};

const handleDeleteKitchenStaff = async (staffId) => {
  if (!window.confirm('Are you sure you want to delete this kitchen staff? This action cannot be undone.')) {
    return;
  }

  const result = await KitchenStaffService.deleteKitchenStaff(restaurantId, staffId);
  
  if (result.success) {
    alert('Kitchen staff deleted successfully');
    await loadKitchenStaff();
  } else {
    alert('Failed to delete kitchen staff');
  }
};
//kot
  const handleSecuritySubmit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);
      setMessage({ type: '', text: '' });

      if (formData.newPassword) {
        if (formData.newPassword !== formData.confirmPassword) {
          setMessage({ type: 'error', text: 'New passwords do not match' });
          setSaving(false);
          return;
        }

        const passwordResult = await AuthService.updatePassword(
          formData.currentPassword,
          formData.newPassword
        );

        if (!passwordResult.success) {
          setMessage({ type: 'error', text: passwordResult.message });
          setSaving(false);
          return;
        }
      }

      const updateData = {
        username: formData.username,
        updatedAt: new Date().toISOString()
      };

      const restaurantRef = doc(db, 'restaurants', restaurantId);
      await updateDoc(restaurantRef, updateData);

      StorageService.clearCache();

      setMessage({ 
        type: 'success', 
        text: formData.newPassword 
          ? '✅ Username and password updated successfully!' 
          : '✅ Username updated successfully!'
      });

      setFormData({
        ...formData,
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });

       

      setTimeout(() => {
        setMessage({ type: '', text: '' });
      }, 3000);
    } catch (error) {
      console.error('❌ Error updating security settings:', error);
      setMessage({ type: 'error', text: 'Failed to update security settings. Please try again.' });
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setMessage({ type: '', text: '' });
  };

  if (loading) {
    return (
      <div className="p-6 flex items-center justify-center min-h-screen">
        <div className="text-center">
          <Loader className="w-12 h-12 text-orange-500 animate-spin mx-auto mb-4" />
          <p className="text-gray-600">Loading settings...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 max-w-6xl mx-auto">
      <div className="mb-6 md:mb-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">Settings</h1>
        <p className="text-sm md:text-base text-gray-600">Manage your restaurant profile and security settings</p>
      </div>

      {message.text && (
        <div className={`mb-4 md:mb-6 p-3 md:p-4 rounded-lg border flex items-start gap-2 md:gap-3 ${
          message.type === 'success' 
            ? 'bg-green-50 border-green-200' 
            : 'bg-red-50 border-red-200'
        }`}>
          {message.type === 'success' ? (
            <CheckCircle className="w-4 h-4 md:w-5 md:h-5 text-green-600 mt-0.5 flex-shrink-0" />
          ) : (
            <AlertCircle className="w-4 h-4 md:w-5 md:h-5 text-red-600 mt-0.5 flex-shrink-0" />
          )}
          <p className={`text-xs md:text-sm font-medium ${
            message.type === 'success' ? 'text-green-700' : 'text-red-700'
          }`}>
            {message.text}
          </p>
        </div>
      )}

      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="flex border-b border-gray-200">
          <button
            onClick={() => handleTabChange('profile')}
            className={`flex-1 px-3 md:px-6 py-3 md:py-4 font-semibold transition flex items-center justify-center gap-2 text-sm md:text-base ${
              activeTab === 'profile'
                ? 'bg-orange-50 text-orange-600 border-b-2 border-orange-500'
                : 'text-gray-600 hover:bg-gray-50'
            }`}
          >
            <Building2 className="w-4 h-4 md:w-5 md:h-5" />
            <span className="hidden sm:inline">Restaurant Profile</span>
            <span className="sm:hidden">Profile</span>
          </button>
         <button
  onClick={() => handleTabChange('security')}
  className={`flex-1 px-3 md:px-6 py-3 md:py-4 font-semibold transition flex items-center justify-center gap-2 text-sm md:text-base ${
    activeTab === 'security'
      ? 'bg-orange-50 text-orange-600 border-b-2 border-orange-500'
      : 'text-gray-600 hover:bg-gray-50'
  }`}
>
  <Shield className="w-4 h-4 md:w-5 md:h-5" />
  <span className="hidden sm:inline">Security Settings</span>
  <span className="sm:hidden">Security</span>
</button>

{/* ✅ NEW KITCHEN STAFF TAB */}
<button
  onClick={() => handleTabChange('kitchen')}
  className={`flex-1 px-3 md:px-6 py-3 md:py-4 font-semibold transition flex items-center justify-center gap-2 text-sm md:text-base ${
    activeTab === 'kitchen'
      ? 'bg-orange-50 text-orange-600 border-b-2 border-orange-500'
      : 'text-gray-600 hover:bg-gray-50'
  }`}
>
  <Users className="w-4 h-4 md:w-5 md:h-5" />
  <span className="hidden sm:inline">Kitchen Staff</span>
  <span className="sm:hidden">Kitchen</span>
</button>

          
        </div>

        {activeTab === 'profile' && (
          <div className="p-4 md:p-8">
            <form onSubmit={handleProfileSubmit} className="space-y-6 md:space-y-8">
              <div>
                <h3 className="text-base md:text-lg font-semibold text-gray-800 mb-3 md:mb-4 flex items-center gap-2">
                  <Building2 className="w-4 h-4 md:w-5 md:h-5 text-orange-500" />
                  <span>Basic Information</span>
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                      Restaurant Name
                    </label>
                    <input
                      type="text"
                      value={formData.name}
                      onChange={(e) => handleChange('name', e.target.value)}
                      className="w-full px-3 md:px-4 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
                      disabled={saving}
                      placeholder="Enter restaurant name"
                    />
                  </div>
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                      GST Number
                    </label>
                    <div className="relative">
                      <FileText className="absolute left-3 top-2.5 md:top-3.5 text-gray-400 w-4 h-4 md:w-5 md:h-5" />
                      <input
                        type="text"
                        value={formData.gstNo}
                        onChange={(e) => handleChange('gstNo', e.target.value)}
                        className="w-full pl-9 md:pl-10 pr-3 md:pr-4 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
                        disabled={saving}
                        placeholder="22AAAAA0000A1Z5"
                      />
                    </div>
                    <p className="text-xs text-gray-500 mt-1">
                      Leave blank if not GST registered
                    </p>
                  </div>
                </div>

                {/* HSN CODE FIELD */}
                <div className="mt-4 md:mt-6">
                  <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                    HSN/SAC Code for Services
                  </label>
                  <div className="relative">
                    <Hash className="absolute left-3 top-2.5 md:top-3.5 text-gray-400 w-4 h-4 md:w-5 md:h-5" />
                    <input
                      type="text"
                      value={formData.hsnCode}
                      onChange={(e) => handleChange('hsnCode', e.target.value)}
                      className="w-full pl-9 md:pl-10 pr-3 md:pr-4 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
                      disabled={saving}
                      placeholder="996331"
                      maxLength="6"
                    />
                  </div>


  {/* ✅ ADD THIS ENTIRE SECTION */}
{/* GOOGLE PLACE ID FIELD */}
                  <div className="md:col-span-1"> {/* Added a div to contain the last input column */}
<div className="mt-4 md:mt-6">
  <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
    Google Place ID (for Reviews)
  </label>
  <div className="relative">
    <Star className="absolute left-3 top-2.5 md:top-3.5 text-gray-400 w-4 h-4 md:w-5 md:h-5" />
    <input
      type="text"
      value={formData.googlePlaceId}
      onChange={(e) => handleChange('googlePlaceId', e.target.value)}
      className="w-full pl-9 md:pl-10 pr-3 md:pr-4 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
      disabled={saving}
      placeholder="ChIJN1t_tDeuEmsRUsoyG83frY4"
    />
  </div>
  <div className="bg-gradient-to-br from-yellow-50 to-orange-50 border border-yellow-200 rounded-lg p-3 md:p-4 mt-2">
    <div className="flex items-start gap-2 mb-2">
      <Star className="w-4 h-4 text-yellow-600 mt-0.5 flex-shrink-0" />
      <div>
        <p className="text-xs md:text-sm font-semibold text-yellow-900 mb-1">
          Enable Google Review Integration
        </p>
        <p className="text-xs text-yellow-800 mb-2">
          Add your Google Place ID to allow customers to leave reviews directly after their meal. This helps boost your restaurant's online presence!
        </p>
      </div>
    </div>
    
    <div className="space-y-2">
      <a
        href="https://developers.google.com/maps/documentation/places/web-service/place-id" // Corrected href syntax
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 text-xs text-blue-600 hover:text-blue-800 hover:underline font-medium"
      >
        📍 How to find your Place ID →
      </a>
      
      {formData.googlePlaceId && (
        <button
          type="button"
          onClick={() => {
            const testUrl = `https://search.google.com/local/writereview?placeid=${formData.googlePlaceId}`;
            window.open(testUrl, '_blank', 'noopener,noreferrer');
          }}
          className="block w-full sm:w-auto bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition flex items-center justify-center gap-2 text-xs md:text-sm font-semibold shadow-sm mt-2"
        >
          <img 
            src="https://www.google.com/favicon.ico" 
            alt="Google" 
            className="w-4 h-4"
          />
          Test Review Link
        </button>
      )}
    </div>
  </div>
</div>
</div> {/* Closing div for the last input column (Google Place ID) */}
        
                  
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mt-2">
                    <p className="text-xs text-blue-800">
                      <strong>Default: 996331</strong> - Services of serving food and beverages in restaurants, cafes and similar eating facilities including takeaway services
                    </p>
                    <p className="text-xs text-blue-700 mt-1">
                      This code will be used in GST-compliant sales reports and invoices.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-base md:text-lg font-semibold text-gray-800 mb-3 md:mb-4 flex items-center gap-2">
                  <Phone className="w-4 h-4 md:w-5 md:h-5 text-orange-500" />
                  <span>Contact Information</span>
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                      Owner Phone Number
                    </label>
                    <div className="relative">
                      <Phone className="absolute left-3 top-2.5 md:top-3.5 text-gray-400 w-4 h-4 md:w-5 md:h-5" />
                      <input
                        type="tel"
                        value={formData.ownerPhone}
                        onChange={(e) => handleChange('ownerPhone', e.target.value)}
                        className="w-full pl-9 md:pl-10 pr-3 md:pr-4 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
                        disabled={saving}
                        placeholder="+91 9876543210"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                      Email Address (Read-only)
                    </label>
                    <div className="relative">
                      <Mail className="absolute left-3 top-2.5 md:top-3.5 text-gray-400 w-4 h-4 md:w-5 md:h-5" />
                      <input
                        type="email"
                        value={formData.email}
                        className="w-full pl-9 md:pl-10 pr-3 md:pr-4 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg bg-gray-50 cursor-not-allowed"
                        disabled
                        readOnly
                      />
                    </div>
                    <p className="text-xs text-gray-500 mt-1">
                      Email cannot be changed after account creation
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-base md:text-lg font-semibold text-gray-800 mb-3 md:mb-4 flex items-center gap-2">
                  <MapPin className="w-4 h-4 md:w-5 md:h-5 text-orange-500" />
                  <span>Location Information</span>
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-4 md:mb-6">
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                      City
                    </label>
                    <input
                      type="text"
                      value={formData.city}
                      onChange={(e) => handleChange('city', e.target.value)}
                      className="w-full px-3 md:px-4 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
                      disabled={saving}
                      placeholder="Mumbai"
                    />
                  </div>
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                      State
                    </label>
                    <input
                      type="text"
                      value={formData.state}
                      onChange={(e) => handleChange('state', e.target.value)}
                      className="w-full px-3 md:px-4 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
                      disabled={saving}
                      placeholder="Maharashtra"
                    />
                  </div>
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                      Country
                    </label>
                    <input
                      type="text"
                      value={formData.country}
                      onChange={(e) => handleChange('country', e.target.value)}
                      className="w-full px-3 md:px-4 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
                      disabled={saving}
                      placeholder="India"
                    />
                  </div>
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                      Pin Code
                    </label>
                    <input
                      type="text"
                      value={formData.pinCode}
                      onChange={(e) => handleChange('pinCode', e.target.value)}
                      className="w-full px-3 md:px-4 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
                      disabled={saving}
                      placeholder="400001"
                      pattern="[0-9]{5,6}"
                      maxLength="6"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                    Full Address
                  </label>
                  <textarea
                    value={formData.address}
                    onChange={(e) => handleChange('address', e.target.value)}
                    className="w-full px-3 md:px-4 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
                    disabled={saving}
                    rows="3"
                    placeholder="Enter complete restaurant address with landmarks..."
                  />
                </div>
              </div>

              <div className="flex justify-end pt-4 md:pt-6 border-t">
                <button
                  type="submit"
                  disabled={saving}
                  className="w-full sm:w-auto bg-orange-500 text-white px-6 md:px-8 py-2.5 md:py-3 rounded-lg font-semibold hover:bg-orange-600 disabled:opacity-50 flex items-center justify-center gap-2 transition shadow-md hover:shadow-lg text-sm md:text-base"
                >
                  {saving ? (
                    <>
                      <Loader className="w-4 h-4 md:w-5 md:h-5 animate-spin" />
                      Saving...
                    </>
                  ) : (
                    <>
                      <Save className="w-4 h-4 md:w-5 md:h-5" />
                      Save Profile
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        )}

        {activeTab === 'security' && (
          <div className="p-4 md:p-8">
            <form onSubmit={handleSecuritySubmit} className="space-y-6 md:space-y-8">
              <div>
                <h3 className="text-base md:text-lg font-semibold text-gray-800 mb-3 md:mb-4 flex items-center gap-2">
                  <User className="w-4 h-4 md:w-5 md:h-5 text-orange-500" />
                  <span>Login Credentials</span>
                </h3>
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 md:p-4 mb-4 md:mb-6">
                  <p className="text-xs md:text-sm text-blue-800 flex items-start gap-2">
                    <AlertCircle className="w-4 h-4 mt-0.5 flex-shrink-0" />
                    <span>Password changes are managed through Firebase Authentication. You must enter your current password to change it.</span>
                  </p>
                </div>
                <div className="grid grid-cols-1 gap-4 md:gap-6">
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                      Username (Read-only)
                    </label>
                    <div className="relative">
                      <User className="absolute left-3 top-2.5 md:top-3.5 text-gray-400 w-4 h-4 md:w-5 md:h-5" />
                      <input
                        type="text"
                        value={formData.username}
                        className="w-full pl-9 md:pl-10 pr-3 md:pr-4 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg bg-gray-50"
                        disabled
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-base md:text-lg font-semibold text-gray-800 mb-3 md:mb-4 flex items-center gap-2">
                  <Lock className="w-4 h-4 md:w-5 md:h-5 text-orange-500" />
                  <span>Change Password</span>
                </h3>
                <div className="grid grid-cols-1 gap-4 md:gap-6">
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                      Current Password *
                    </label>
                    <div className="relative">
                      <Lock className="absolute left-3 top-2.5 md:top-3.5 text-gray-400 w-4 h-4 md:w-5 md:h-5" />
                      <input
                        type="password"
                        value={formData.currentPassword}
                        onChange={(e) => handleChange('currentPassword', e.target.value)}
                        className="w-full pl-9 md:pl-10 pr-3 md:pr-4 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
                        required={formData.newPassword.length > 0}
                        disabled={saving}
                        placeholder="Required to change password"
                      />
                    </div>
                  </div>    
  
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                      New Password *
                    </label>
                    <div className="relative">
  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4 md:w-5 md:h-5" />
  <input
    type={showNewPassword ? 'text' : 'password'}
    value={formData.newPassword}
    onChange={(e) => handleChange('newPassword', e.target.value)}
    className="w-full pl-9 md:pl-10 pr-10 md:pr-12 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
    required
    disabled={saving}
    placeholder="Enter new password (min 6 characters)"
    minLength={6}
  />
  <button
    type="button"
    onClick={() => setShowNewPassword(!showNewPassword)}
    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
    disabled={saving}
  >
    {showNewPassword ? (
      <EyeOff className="w-4 h-4 md:w-5 md:h-5" />
    ) : (
      <Eye className="w-4 h-4 md:w-5 md:h-5" />
    )}
  </button>

  {/* <button
  onClick={() => handleTabChange('kitchen')}
  className={`flex-1 px-3 md:px-6 py-3 md:py-4 font-semibold transition flex items-center justify-center gap-2 text-sm md:text-base ${
    activeTab === 'kitchen'
      ? 'bg-orange-50 text-orange-600 border-b-2 border-orange-500'
      : 'text-gray-600 hover:bg-gray-50'
  }`}
>
  <Users className="w-4 h-4 md:w-5 md:h-5" />
  <span className="hidden sm:inline">Kitchen Staff</span>
  <span className="sm:hidden">Kitchen</span>
</button> */}

</div>

                  </div>
                  
                  <div>
                    <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1.5 md:mb-2">
                      Confirm New Password *
                    </label>
                   <div className="relative">
  <Lock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4 md:w-5 md:h-5" />
  <input
    type={showConfirmPassword ? 'text' : 'password'}
    value={formData.confirmPassword}
    onChange={(e) => handleChange('confirmPassword', e.target.value)}
    className="w-full pl-9 md:pl-10 pr-10 md:pr-12 py-2 md:py-3 text-sm md:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition"
    required
    disabled={saving}
    placeholder="Confirm new password"
    minLength={6}
  />
  <button
    type="button"
    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
    className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
    disabled={saving}
  >
    {showConfirmPassword ? (
      <EyeOff className="w-4 h-4 md:w-5 md:h-5" />
    ) : (
      <Eye className="w-4 h-4 md:w-5 md:h-5" />
    )}
  </button>
</div>

                  </div>
                </div>
              </div>

              <div className="flex justify-end pt-4 md:pt-6 border-t">
                <button
                  type="submit"
                  disabled={saving}
                  className="w-full sm:w-auto bg-orange-500 text-white px-6 md:px-8 py-2.5 md:py-3 rounded-lg font-semibold hover:bg-orange-600 disabled:opacity-50 flex items-center justify-center gap-2 transition shadow-md hover:shadow-lg text-sm md:text-base"
                >
                  {saving ? (
                    <>
                      <Loader className="w-4 h-4 md:w-5 md:h-5 animate-spin" />
                      Updating...
                    </>
                  ) : (
                    <>
                      <Shield className="w-4 h-4 md:w-5 md:h-5" />
                      Change Password
                    </>
                  )}
                </button>
              </div>
            </form>

            <div className="mt-6 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
              <div className="flex items-start gap-2">
                <AlertCircle className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" />
                <div className="text-sm text-yellow-800">
                  <p className="font-semibold mb-1">Important:</p>
                  <ul className="list-disc list-inside space-y-1">
                    <li>After changing your password, you will be automatically logged out</li>
                    <li>You must login again with your new password</li>
                    <li>Make sure to remember your new password</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}



        {activeTab === 'kitchen' && (
  <div className="p-4 md:p-8">
    <div className="flex justify-between items-center mb-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-800">Kitchen Staff Accounts</h3>
        <p className="text-sm text-gray-600 mt-1">
          Create separate logins for your kitchen staff to manage orders
        </p>
      </div>
      <button
        onClick={() => setShowKitchenModal(true)}
        className="bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 flex items-center gap-2"
      >
        <Plus className="w-4 h-4" />
        Add Staff
      </button>
    </div>

    {kitchenStaff.length === 0 ? (
      <div className="text-center py-12 bg-gray-50 rounded-lg">
        <Users className="w-16 h-16 text-gray-300 mx-auto mb-4" />
        <p className="text-gray-600">No kitchen staff accounts yet</p>
        <button
          onClick={() => setShowKitchenModal(true)}
          className="mt-4 text-orange-500 hover:text-orange-600 font-medium"
        >
          Create your first kitchen staff account
        </button>
      </div>
    ) : (
      <div className="space-y-4">
        {kitchenStaff.map(staff => (
          <div key={staff.id} className="bg-white border rounded-lg p-4 flex justify-between items-center">
            <div>
              <h4 className="font-semibold text-gray-800">{staff.name}</h4>
              <p className="text-sm text-gray-600">{staff.email}</p>
              <div className="flex gap-2 mt-2">
                <span className={`text-xs px-2 py-1 rounded ${
                  staff.active ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'
                }`}>
                  {staff.active ? 'Active' : 'Inactive'}
                </span>
                {staff.deviceId && (
                  <span className="text-xs px-2 py-1 rounded bg-blue-100 text-blue-700">
                    Device Connected
                  </span>
                )}
              </div>
              {staff.lastLogin && (
                <p className="text-xs text-gray-500 mt-1">
                  Last login: {new Date(staff.lastLogin).toLocaleString()}
                </p>
              )}
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => handleToggleKitchenStaff(staff.id, staff.active)}
                className={`px-3 py-1.5 rounded text-sm ${
                  staff.active
                    ? 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200'
                    : 'bg-green-100 text-green-700 hover:bg-green-200'
                }`}
              >
                {staff.active ? 'Deactivate' : 'Activate'}
              </button>
              <button
                onClick={() => handleDeleteKitchenStaff(staff.id)}
                className="px-3 py-1.5 rounded text-sm bg-red-100 text-red-700 hover:bg-red-200"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    )}

    {/* Create Kitchen Staff Modal */}
    {showKitchenModal && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
        <div className="bg-white rounded-xl p-6 w-full max-w-md">
          <h3 className="text-xl font-bold mb-4">Add Kitchen Staff</h3>
          <form onSubmit={handleCreateKitchenStaff} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Name *</label>
              <input
                type="text"
                value={kitchenFormData.name}
                onChange={(e) => setKitchenFormData({...kitchenFormData, name: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Email *</label>
              <input
                type="email"
                value={kitchenFormData.email}
                onChange={(e) => setKitchenFormData({...kitchenFormData, email: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Password *</label>
              <input
                type="password"
                value={kitchenFormData.password}
                onChange={(e) => setKitchenFormData({...kitchenFormData, password: e.target.value})}
                className="w-full px-3 py-2 border rounded-lg"
                minLength="6"
                required
              />
              <p className="text-xs text-gray-500 mt-1">Minimum 6 characters</p>
            </div>
            <div className="flex gap-3 pt-4">
              <button
                type="button"
                onClick={() => {
                  setShowKitchenModal(false);
                  setKitchenFormData({ name: '', email: '', password: '' });
                }}
                className="flex-1 px-4 py-2 border rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={kitchenSaving}
                className="flex-1 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 disabled:opacity-50"
              >
                {kitchenSaving ? 'Creating...' : 'Create Staff'}
              </button>
            </div>
          </form>
        </div>
      </div>
    )}
  </div>
)}




      </div>
    </div>
  );
};

export default OwnerSettings;